import type { Msg } from '@halo/chat-sdk-react';
import { serializePayload } from '@halo/ui-chat-react';
import { useStaticAppStore } from '@/store/client';

export interface MsgTextPreviewContentProps {
  message: Msg;
}

export const MsgTextPreviewContent = memo(function MsgTextPreviewContent({
  message,
}: MsgTextPreviewContentProps) {
  const { user } = useStaticAppStore();

  const text = useMemo(() => {
    return serializePayload.deserialize(
      message.payload,
      [
        {},
        {
          currentUserId: user?.user_id,
          senderId: message.owner_id,
          readerIds: message.at_read_list,
          normal: true,
        },
        {},
      ],
      [
        {
          preview: true,
        },
        {},
        {},
      ]
    );
  }, [message, user?.user_id]);

  return text;
});
